import {getDominantBlockType, withX, withType, getBlocks} from '../calculateRules.js';
import {deleteCell, clearBlock} from './delete.js';
import {add} from './add.js';
import {append} from './append.js';
import {shift} from './shift.js';
import {save, restore} from './session.js';

export const definitions = {
    clearBlock,
    "delete": deleteCell,
    add,
    append,
    shift,
    save,
    restore
};
